export default __webpack_public_path__ + "0fb2ce00911032e6123d1d606c6ada5a.svg";